import type { VideoPlaybackControls } from "../lib/use-video-playback";

/**
 * Where a video's frames appear: the `<video>` the browser decodes into, or the `<canvas>` the
 * software decoder draws on. Only the one in use is shown.
 */
export function VideoSurface({
  player,
  className,
}: {
  player: Pick<VideoPlaybackControls, "videoRef" | "canvasRef" | "software">;
  className?: string;
}) {
  return (
    <>
      {/* biome-ignore lint/a11y/useMediaCaption: Pax videos have no caption tracks */}
      <video
        ref={player.videoRef}
        hidden={player.software}
        playsInline
        preload="metadata"
        className={className}
      />
      <canvas ref={player.canvasRef} hidden={!player.software} className={className} />
    </>
  );
}
